module.exports = __webpack_public_path__ + "static/img/pro-7-2-2.bf5e44d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/pro-7-2-2.png
// module id = zF4/
// module chunks = 0